import styled from 'styled-components'

const Main = styled.main`
  .container {
    @media only screen and (min-width: 992px) {
      max-width: 1140px;
    }
    @media only screen and (min-width: 1200px) {
      max-width: 1280px;
    }
  }
`

export default Main
